export enum HourCode {
  SHORT = "h",
}
